import PropTypes from "prop-types";
import AiCorner from "../assets/ai_avatar.jpg";

// 導入需要的 hooks 和 context
import { useDemand } from "../../../context/DemandContext";
import { useFilesByIds } from "../../../context/FileManagementContext";

const MessageLoading = ({ message }) => {
  const isAi = message.sender === "ai";

  // 從 DemandContext 獲取數據
  const { state } = useDemand();
  
  // 獲取頭像檔案 IDs
  const avatarFileIds = state.ceremony?.liveStream?.files?.my?.photo?.map(file => file.fileId) || [];
  const avatarFiles = useFilesByIds(avatarFileIds);
  
  // 獲取 AI 名稱
  const aiName = state.basic?.name || "Panco AI小助理";
  
  // 使用第一個頭像，如果沒有則使用預設圖片
  const avatarUrl = avatarFiles.length > 0 && avatarFiles[0]?.url ? avatarFiles[0].url : AiCorner;

  if (message.isLoading) {
    return (
      <div
        className={`flex w-fit max-w-[100%] flex-col gap-1 ${
          !isAi ? "self-end" : "self-start"
        }`}
      >
        {isAi && (
          <div className="flex items-center gap-3">
            <div className="relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-white">
              <img
                src={avatarUrl}
                alt="ai-avatar"
                className="h-auto w-full object-cover"
              />
            </div>
            <span className="text-xs font-semibold text-white">{aiName}</span>
          </div>
        )}
        <div className="flex min-h-8 items-center gap-2">
          <div
            className={`h-full rounded p-2 ${
              isAi ? "ml-10 bg-[#00000080] text-white" : "bg-[#00000080]"
            }`}
          >
            <div className="flex h-full items-center gap-3">
              <div className="animate-scale h-1.5 w-1.5 rounded-full bg-[#ffffff]"></div>
              <div className="animate-scale h-1.5 w-1.5 rounded-full bg-[#ffffff] delay-100"></div>
              <div className="animate-scale h-1.5 w-1.5 rounded-full bg-[#ffffff] delay-200"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default MessageLoading;

MessageLoading.propTypes = {
  message: PropTypes.shape({
    text: PropTypes.string.isRequired,
    sender: PropTypes.string.isRequired,
    createdAt: PropTypes.string,
    isLoading: PropTypes.bool,
  }).isRequired,
};
